var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{class:_vm.selectClass,attrs:{"id":_vm.id,"options":_vm.options,"placeholder":_vm.placeholder,"label":_vm.selectLabel,"value":_vm.value,"searchable":false},on:{"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }